import { InstagramComponent, TwitterComponent, FacebookComponent, DoordashComponent } from "./externallink";
import { useState } from "react";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function Footer() {
    const [email, setEmail] = useState("");
    const [responseMessage, setResponseMessage] = useState("");
    const handleFormSubmission = async (e) => {
        e.preventDefault();
        const requestData = 
        {
          "data": 
            {
                "subscriber": email,
            }
        };

        try {
          const response = await fetch(`${REACT_APP_API_URL}}newsletters`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });
    
          const data = await response.json();
          setResponseMessage(data.message);
          setEmail("")
        } catch (error) {
          console.error("Error:", error);
          setResponseMessage("Something went wrong!");
        }
      };
    return (
        <section id="footerSection">
            <div className="container-fluid border-top border-dark border-2" style={{backgroundColor: "gray"}}>
                <div className="d-flex flex-column">
                    <div className="mx-auto">
                        <ul className="d-flex flex-row" style={{listStyleType: "none"}}>
                            <InstagramComponent className={"nav-item mx-4"}/>
                            <FacebookComponent className={"nav-item mx-4"}/>
                            <TwitterComponent className={"nav-item mx-4"}/>
                            <DoordashComponent className={"nav-item mx-4"}/>
                        </ul>
                    </div>
                    <div className="d-flex flex-row mx-auto">
                      <div className="my-auto" style={{width: "40%"}}>
                          <h2 className="text-start" style={{fontWeight: "boldder", fontSize: "clamp(1em,1vw,1.5em)"}}>Contact Us For A Customized Experience!</h2>
                      </div>
                      <div style={{width: "60%"}}>
                          <form className="form w-100" onSubmit={handleFormSubmission}>
                              <label for="email">Email</label>
                              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className='form-control' style={{backgroundColor: 'transparent', borderColor: "black"}} name="email" id="email"/>
                              <button className="btn btn-dark my-4" type='submit'>Contact</button>
                          </form>
                      </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default Footer;  